module.exports = __webpack_public_path__ + "media/star_blaze.ff3db515.webm";